var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrfilterreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2765_8217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_2765_8217)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2765_8217)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5,
    cy: 12.5,
    rx: 18.5,
    ry: 20.5,
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2765_8217",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2765_8217",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2765_8217",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACxQAAAsUBidZ/7wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAKuSURBVHic7do/alZBGEbxZ8S1iKU7UBAhlViIvZVrsLPTRSi4ACsrRYQUFi4ihYILsDAgpHjdgEhucu/88ZwfpEvue8McvmGYr1VVLqu1dprk7qX/QFf1sapOegy60WOI5mUAcAYAZwBwBgBnAHA3d3zW9yRvd3we2VmvQXsG8K2qXuz4PHXgFgBnAHAGAGcAcAYAZwBwex4D/8mr5G42XSX7CQBnAHAGAGcAcAYAZwBwBgBnAHAGAGcAcAYAZwBwBgBnAHDdroMHepjk04C5D5K8HzB3E0IAF1X1u/fQ1tpF75lX4RYAZwBwBgBnAHAGAEc4BTxprd0ZMPfWgJmbEQJ4OvoFZuYWAGcAcAYAZwBwBgBnAHCrHANHXemO0u0qeZUAhlzpjtLzKtktAM4A4AwAzgDgDABulVPAqCvdUbpdJa8SgFe6B3ELgDMAOAOAMwA4A4AzALhVjoGPk3we/RId3U/yrsegVQI4r6qfo1+il9baea9ZbgFwBgBnAHAGAGcAcKucAh611m6PfomOuv2vqwTwbPQL/K/cAuAMAM4A4AwAzgDgDABulWOg18EHWSUAr4MP4hYAZwBwBgBnAHAGALfKKcDr4IOsEoDXwQdxC4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAuFW+ELK6N0l+dJp1tuWXDaCP11X1dfRL/I1bAJwBwBkAnAHAGQCcAcAZwGCttZPWWl3x5+V15xvAul5V1fPrPsQA1rTL4icGsKLdFj8xgNXsuvjJxruAqrq353BtsvviJ34CrOKQxU8MYAWHLX5iALM7dPETA5jZ4YufGMCsuix+YgAz6rb4iQHMpuviJwYwk+6LnxjALIYsfuK3gmfwpao+jBruJ8BgVfVr5HwDgDMAOAOA+wPBvpHjrc99iQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrfilterreport);
export default __webpack_public_path__ + "static/media/hrfilterreport.f5d6c83ed9f512b6c872c09026e4fe8b.svg";
export { ForwardRef as ReactComponent };